import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { handleQuerySuccess } from '../../../../hooks/useQuriesSuccess';
import { apiRequest } from './../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import useDeleteMutation from '../../../../hooks/apis/useDeleteMutaion';
import useSaveMutation from '../../../../hooks/apis/useSaveMutaion';
import { mapParamsBySchema, mapRowsBySchema } from '../../../../util';
import { SAP_BASIC_02_Schema } from './SAP_BASIC_02_Schema';
import useSearchMutaion from '../../../../hooks/apis/useSearchMutaion';
export const useSearchCode = (options = {}) => {
  const { onSuccess } = options;

  const query = useQuery({
    queryKey: ['Utility', 'getCodeInfo'],
    queryFn: () => apiRequest('post', Global.urls.Utility.getCodeInfo),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

export const useSearch1 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(SAP_BASIC_02_Schema.mapper.search1);

  const query = useQuery({
    queryKey: ['SafetyPersonnel', 'getSapBasic02R1', params],
    queryFn: () =>
      apiRequest('post', Global.urls.SafetyPersonnel.getSapBasic02R1, params),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};
export const useSearch2 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(
      SAP_BASIC_02_Schema.mapper.search2,
      context
    );
    return apiRequest(
      'post',
      Global.urls.SafetyPersonnel.getSapBasic02R2,
      params
    );
  }, successOptions);
};

export const useSave1 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, SAP_BASIC_02_Schema.mapper.save1);
    return apiRequest(
      'post1',
      Global.urls.SafetyPersonnel.saveSapBasic02U1,
      payload
    );
  }, options);
};
export const useSave2 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, SAP_BASIC_02_Schema.mapper.save2);
    return apiRequest(
      'post1',
      Global.urls.SafetyPersonnel.saveSapBasic02U2,
      payload
    );
  }, options);
};
export const useDelete1 = (options = {}) => {
  return useDeleteMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, SAP_BASIC_02_Schema.mapper.delete1);

    return apiRequest(
      'post1',
      Global.urls.SafetyPersonnel.deleteSapBasic02D1,
      payload
    );
  }, options);
};
